'use strict';

/* global YT */

const SELECTOR = '[data-youtube-id]';
const playingClass = 'playing';

export function init() {
    const els = document.querySelectorAll(SELECTOR);

    if (!els.length) {
        return;
    }

    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
        els.forEach(el => {
            const videoCode = el.dataset.youtubeId;
            const elemId = el.attributes.getNamedItem('id').value;
            const videoContainer = el.closest('.js-inline-video');
            const playerVars = {
                'playlist': videoCode,
                'autoplay': 0,
                'controls': 1,
                'loop': 0,
                'modestbranding': 1,
                'playsinline': 1,
                'rel': 0,
                'enablejsapi': 1
            };

            new YT.Player(elemId, {
                height: '390',
                width: '640',
                videoId: videoCode,
                playerVars,
                events: {
                    'onStateChange': onPlayerStateChange
                }
            });

            function onPlayerStateChange(event) {
                switch(event.data) {
                    case YT.PlayerState.UNSTARTED:  // This is in case the "Sign in to confirm that you're not a bot" message appears
                    case YT.PlayerState.PLAYING:
                        if(videoContainer){
                            videoContainer.classList.add(playingClass);
                        }
                        break;
                }
            }
        });
    }
}


